import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import * as TextManager from "../../../modules/languages/TextManager";
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {logout} from '../../../redux/actions/UserActions'
import {main_dashbaord_show_hello} from '../../../redux/actions/MainDashboardActions';

class SidebarContent extends Component {
    static propTypes = {
        changeToDark: PropTypes.func.isRequired,
        changeToLight: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    hideSidebar = () => {
        this.props.onClick();
    };

    render() {

        return (
            <div className="sidebar__content">
                <ul className="sidebar__block">
                    <SidebarLink title={TextManager.getCurrentTextResource().Dashboard.DashboardName} icon="home" route="/dashboard"/>
                    <SidebarLink title={TextManager.getCurrentTextResource().Text.sales} icon='plus-circle' route='/sales'/>

                    {
                        this.props.userData && this.props.userData.data &&
                        (this.props.userData.data.isAdmin || (this.props.userData.data.isManager && this.props.userData.data.userType !== 5)) &&
                        <SidebarLink title={TextManager.getCurrentTextResource().Text.providers} icon='book'
                                     route='/providers'/>
                    }

                    <SidebarLink title={TextManager.getCurrentTextResource().Customers.customers} icon='list' route='/customers'/>
                    {
                        this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin &&
                        <SidebarLink title={TextManager.getCurrentTextResource().Settings.settings} icon='cog' route='/settings'/>
                    }

                    <SidebarLink title='טפסים להורדה' icon='file-empty'
                                 onClick={(e) => {
                                     e.preventDefault();
                                     window.open('https://www.s-romi.co.il/s-romi-form', '_blank');
                                 }}/>

                    {
                        this.props.userData && this.props.userData.data &&
                        (this.props.userData.data.userType !== 5) && <SidebarLink title={TextManager.getCurrentTextResource().Text.orders} icon='pencil' route='/orders'/>
                    }
                    <SidebarCategory title='לסינון והשוואת חבילות' icon='layers'>
                        <li className='sidebar__link' onClick={(e) => {
                            e.preventDefault();
                            window.open('https://www.xn----9hcabjkdpofb7b5f.co.il/%d7%94%d7%a9%d7%95%d7%95%d7%90%d7%aa-%d7%9e%d7%97%d7%99%d7%a8%d7%99-%d7%a1%d7%9c%d7%95%d7%9c%d7%a8/', '_blank');
                        }}>
                            <p className='sidebar__link-title'>לסינון והשוואה בסלולר</p>
                        </li>
                        <li className='sidebar__link' onClick={(e) => {
                            e.preventDefault();
                            window.open('https://www.xn----9hcabjkdpofb7b5f.co.il/%d7%94%d7%a9%d7%95%d7%95%d7%90%d7%aa-%d7%9e%d7%97%d7%99%d7%a8%d7%99-%d7%90%d7%99%d7%a0%d7%98%d7%a8%d7%a0%d7%98/', '_blank');
                        }}>
                            <p className='sidebar__link-title'>לסינון והשוואה באינטרנט</p>
                        </li>
                        <li className='sidebar__link' onClick={(e) => {
                            e.preventDefault();
                            window.open('https://www.xn----9hcabjkdpofb7b5f.co.il/%d7%94%d7%a9%d7%95%d7%95%d7%90%d7%aa-%d7%9e%d7%97%d7%99%d7%a8%d7%99-%d7%98%d7%9c%d7%95%d7%95%d7%99%d7%96%d7%99%d7%94/', '_blank');
                        }}>
                            <p className='sidebar__link-title'>לסינון והשוואה בטלוויזיה וטריפל</p>
                        </li>
                        <li className='sidebar__link' onClick={(e) => {
                            e.preventDefault();
                            window.open('https://www.xn----9hcabjkdpofb7b5f.co.il/%d7%94%d7%a9%d7%95%d7%95%d7%90%d7%aa-%d7%9e%d7%97%d7%99%d7%a8%d7%99-%d7%a7%d7%95%d7%95%d7%99-%d7%98%d7%9c%d7%a4%d7%95%d7%9f/', '_blank');
                        }}>
                            <p className='sidebar__link-title'>לסינון והשוואה בקווים נייחים</p>
                        </li>
                    </SidebarCategory>
                </ul>
                <ul className="sidebar__block">
                    <SidebarLink title={TextManager.getCurrentTextResource().Text.LogOut} icon='exit' route='/dashboard'
                                 onClick={()=>{ this.props.dispatch(logout());
                                                this.props.dispatch(main_dashbaord_show_hello())}}/>
                </ul>
            </div>
        );
    }
}

export default withRouter(connect(state => {
    return {
        userData:state.userData
    };
})(SidebarContent));
